import { mainBlue, white } from "@u4i/styles/styles-variables";
import * as React from "react";
import { opacity7 } from "../../constants/Constants";
import { mapModuleStyling } from "../../constants/StaticMethods";

interface IPropTypes {
  cx: number
  cy: number
  isCompleted: boolean
  radius: number
  required: boolean
  title: string
  onModuleHover: (cx: number, cy: number, title: string, hoverIn: boolean) => void 
  showModuleInVE: () => void
}

export const SelfReflectionIcon = (props: IPropTypes) => {
  const {
    cx,
    cy,
    isCompleted,
    radius,
    required,
    title,
    onModuleHover,
    showModuleInVE
  } = props;

  const [opacity, setOpacity] = React.useState<boolean>(false);

  const handleOpacity = () => {
    opacity ? setOpacity(false) : setOpacity(true);
  }
  
  const moduleHover = (mouseEnter: boolean) => {
    onModuleHover(cx, cy, title, mouseEnter);
  }

  return (
    <svg>
      <g
        onClick={showModuleInVE}
        onMouseEnter={() => { handleOpacity(); moduleHover(true); }}
        onMouseLeave={() => { handleOpacity(); moduleHover(false); }}
        style={{ cursor: "pointer", ...(opacity && { opacity: opacity7 }) }}
      >
        <circle
          cx={cx}
          cy={cy}
          r={isCompleted ? radius : radius-3}
          style={mapModuleStyling(isCompleted)}
        >
        </circle>
        <g fill={isCompleted ? white : mainBlue}>
          <path
            d={`m ${cx},${cy-9} c -0.845216,0 -1.543437,0.706319 -1.543437,1.561338 0,0.855019 0.698221,1.561338 1.543437,1.561338 0.845215,0 1.543436,-0.706319 1.543436,-1.561338 0,-0.855019 -0.698221,-1.561338 -1.543436,-1.561338 z`}
            style={{strokeWidth: 0.5}}
          />
          <ellipse
            cx={cx - 4.5}
            cy={cy + 0.5}
            rx={1.54}
            ry={1.56}
            style={{strokeWidth: 0.5}}
          />
          <path
            d={`m ${cx + 4.5},${cy - 7} c -0.649003,0.229102 -1.218844,0.597259 -1.260912,1.337836 0.100971,0.433574 0.542165,0.945006 -0.02399,1.225913 -0.283585,0.569329 -0.758493,0.310987 -1.216377,0.126292 -0.728343,-0.06547 -1.173942,0.529668 -1.394057,1.176129 -0.419512,-0.08483 -1.105214,0.251279 -1.196365,-0.35281 -0.145068,-0.656604 -0.930595,-1.062545 -1.524324,-0.756257 -0.520073,0.39744 -0.822651,-0.146011 -1.172068,-0.486832 -0.117375,-0.502543 0.574354,-1.130536 -0.01407,-1.644691 -0.05003,-0.549939 -1.14491,-0.339332 -0.980726,-0.975166 -0.118996,-0.551637 0.06833,-0.91149 0.632321,-1.035516 0.620516,-0.27573 0.681167,-1.136023 0.389849,-1.704131 -0.111532,-0.353174 0.500193,-0.9181 0.815689,-0.911188 0.584147,0.33912 1.438835,0.310398 1.750426,-0.333873 0.124481,-0.551236 0.453387,-0.779204 1.009978,-0.647119 0.639286,-0.178013 0.437939,0.900663 0.981192,0.954926 0.527097,0.680835 1.244788,-0.292934 1.714476,0.1039 0.405,0.324731 0.727779,0.668277 0.367957,1.16803 -0.290313,0.613989 0.201031,1.341266 0.83461,1.500252 0.548252,0.127348 0.18023,0.828363 0.286392,1.232498 z m -4.63031,7.546467 c -0.648924,0.228226 -1.20969,0.586785 -1.226721,1.338662 0.136441,0.469894 0.456801,0.985222 -0.113092,1.280631 -0.281393,0.57881 -0.791543,0.168013 -1.235184,0.04494 -0.802488,-0.04511 -1.025207,0.726016 -1.361697,1.20194 -0.444071,-0.04599 -1.078908,0.209679 -1.151744,-0.423372 -0.158949,-0.662142 -0.983961,-0.973902 -1.570576,-0.678086 -0.521463,0.361122 -0.786262,-0.305605 -1.147242,-0.587162 0.197563,-0.604007 0.447064,-1.205792 -0.02117,-1.805804 -0.339006,-0.258354 -1.096918,-0.254436 -0.918713,-0.83661 -0.167637,-0.58209 0.194307,-0.832616 0.702579,-0.991528 0.590075,-0.345722 0.582896,-1.168125 0.268723,-1.735647 -0.03962,-0.315473 0.527522,-0.865502 0.829807,-0.845556 0.584147,0.33912 1.438835,0.310397 1.750426,-0.333872 0.124482,-0.551236 0.453386,-0.779206 1.009979,-0.647121 0.560153,-0.152333 0.550341,0.596654 0.803765,0.929369 0.604101,0.616991 1.31127,-0.0153 1.873743,0.111088 0.339399,0.339742 0.835243,0.643683 0.448153,1.149677 -0.321953,0.595558 0.102174,1.37544 0.739066,1.540034 0.611371,0.0921 0.253695,0.76891 0.323208,1.187959 l -0.0026,0.07806 -7.38e-4,0.0224 z m 12.714978,1.375464 c -0.845215,-1.486988 -1.690431,-2.973977 -2.535646,-4.460965 0.297433,-4.695525 -2.662743,-9.401307 -7.091531,-11.046411 -4.394258,-1.779383 -9.814469,-0.25233 -12.653086,3.539334 -3.610398,4.588724 -3.023941,11.910745 1.370851,15.791482 0.714919,0.3098 0.659431,0.963244 0.624244,1.619437 0,2.77059 0,5.541181 0,8.311771 3.870841,0 7.741683,0 11.612524,0 0,-1.486989 0,-2.973978 0,-4.460967 1.572271,0.0086 3.32122,0.150318 4.571024,-1.010397 1.318546,-1.046491 1.67383,-2.789873 1.565974,-4.387799 0.09652,-0.386632 -0.198365,-1.16467 0.156205,-1.293253 0.920553,-0.02443 2.143813,0.228941 2.609119,-0.827135 0.280863,-0.576709 0.109925,-1.263311 -0.229678,-1.775097 z`}
            style={{strokeWidth: 0.8}}
          />
        </g>
      </g>
    </svg>
  );
}
